<template>
	<div class="token-stat-page">
		<el-form inline label-width="80px">
			<el-form-item label="选择学期">
				<el-select v-model="semesterId" placeholder="请选择学期" @change="handleSemesterChange">
					<el-option
						v-for="item in semesterList"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					/>
				</el-select>
			</el-form-item>
		</el-form>
		<div class="card-wrap" ref="scrollContainer" @scroll="onScroll">
			<div class="card-grid">
				<div class="project-card" v-for="item in tableData" :key="item.id">
					<!-- 右上角图标区域，和智能体广场位置完全一致 -->
					<div class="card-icon">
						<img v-if="item.url" :src="item.url" class="cover-img" />
						<div class="icon-placeholder"></div>
					</div>
				
					<!-- ==========新增：右下角三点下拉菜单========== -->
					<el-dropdown trigger="click" @command="(cmd)=>handleCardMenu(cmd, item)" class="card-more-wrap">
						<div class="more-btn">
							<i class="el-icon-more" style="transform: rotate(90deg);color: #409EFF;"></i>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="viewReport">查看报告</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				
					<div class="card-title-row">
						<span class="title">{{ item.aiStandardModelName || "未命名模型" }}</span>
					</div>
					<p class="card-id-text" style="color: #409EFF;">课程:{{ item.statCount }}</p>
					<p class="card-desc" :title="item.description">
						{{ item.description || "暂无说明" }}
					</p>
					<div class="card-bottom">
						<div class="author-line">
							<span>{{ formatTsToDate(item.updateTime) }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="load-tip" v-if="loading">
				<i class="el-icon-loading" style="font-size: 30px;color: #409EFF;"></i>
				<span style="font-size: 30px;color: #409EFF;"> 加载中...</span>
			</div>
			<div class="load-tip no-more" v-if="noMore && tableData.length > 0">没有新数据了！</div>
			<div class="empty-tip" v-if="!loading && tableData.length === 0">暂无数据</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			tableData: [],
			semesterList: [],
			semesterId: null,
			currentSemester: null,
			loadingIns: null,
			pageNum: 1,
			pageSize: 10,
			total: 0,
			loading: false,
			noMore: false
		}
	},
	created() {
		this.initSemester()
	},
	methods: {
		loadingOpen(text) {
			this.loadingIns = this.$loading({
				lock: true,
				text,
				zIndex: 100001,
				spinner: 'el-icon-loading',
				background: 'rgba(0,0,0,0.7)'
			})
		},
		handleCardMenu(cmd, item) {
		  switch (cmd) {
		    case 'viewReport':
		      this.viewReport(item);
		      break;
		  }
		},
		// 查看报告，在这里写你的弹窗/跳转逻辑
		viewReport(item) {
		  console.log('查看报告', item);
		  // TODO 业务实现示例：
		  // 1. 打开el-dialog弹窗展示报告
		  // 2. 或者 this.$router.push('/xxx/report?id=' + item.id)
		  // 3. 或者调用接口下载报告文件
		  this.$message.info("设计中...");
		},
		loadingClose() {
			if (this.loadingIns) {
				this.loadingIns.close()
				this.loadingIns = null
			}
		},
		initSemester() {
			const semesterStr = localStorage.getItem('semester')
			if (!semesterStr) {
				this.$message.warning('本地未获取到学期数据')
				return
			}
			const rawList = JSON.parse(semesterStr)
			this.semesterList = rawList
				.filter(v => v.status !== 0)
				.map(v => {
					return {
						label: `${v.year}-${Number(v.year) + 1}学年${v.term === 1 ? '第一学期' : '第二学期'}`,
						value: v.id,
						year: v.year,
						term: v.term
					}
				})
			const active = this.semesterList.find(v => rawList.find(r => r.id === v.value && r.status === 1))
			if (active) {
				this.semesterId = active.value
				this.currentSemester = active
				this.fetchProjectList(true)
			}
		},
		formatTsToDate(timestamp) {
			if (!timestamp) return ''
			let time = Number(timestamp)
			// 判断是秒级时间戳（10位），转为毫秒
			if (time.toString().length === 10) {
				time = time * 1000
			}
			const date = new Date(time)
			// 补零函数 0~9 → 01、02
			const padZero = n => n < 10 ? '0' + n : n
			const year = date.getFullYear()
			const month = padZero(date.getMonth() + 1) // 月份从0开始
			const day = padZero(date.getDate())
			const hour = padZero(date.getHours())
			const minute = padZero(date.getMinutes())
			const second = padZero(date.getSeconds())
			return `${year}-${month}-${day} ${hour}:${minute}:${second}`
		},
		handleSemesterChange() {
			this.currentSemester = this.semesterList.find(item => item.value === this.semesterId)
			if (!this.currentSemester) return
			this.fetchProjectList(true)
		},
		async fetchProjectList(reset = false) {
			if (this.loading) return
			this.loading = true
			if (reset) {
				this.pageNum = 1
				this.tableData = []
				this.noMore = false
			}
			this.loadingOpen('查询数据中...')
			try {
				const res = await this.API.get(this.API.school.getHtmlModelList, {
					year: this.currentSemester.year,
					term: this.currentSemester.term,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				})
				const apiData = res?.data || {}
				const records = Array.isArray(apiData.records) ? apiData.records : []
				this.total = apiData.total || 0

				// 初始化：设置占位图，promotionalImage不为空后续后台异步替换真实url
				const tempList = records.map((item, idx) => {
					return {
						...item,
						index: (this.pageNum - 1) * this.pageSize + idx + 1,
						// 无图片用默认占位图标，和智能体广场保持一致
						url: item.promotionalImage ? require('@/ico/loading.svg') : require('@/ico/agaenNo.png'),
						imgLoaded: false
					}
				})

				if (tempList.length > 0) {
					this.tableData.push(...tempList)
				}

				const loadedTotal = this.pageNum * this.pageSize
				if (loadedTotal >= this.total || records.length === 0) {
					this.noMore = true
				} else {
					this.pageNum += 1
				}

				// 【核心】模仿智能体广场：后台串行加载OSS图片，不阻塞页面渲染
				const loadImageSerial = async () => {
					for (let i = 0; i < tempList.length; i++) {
						const row = tempList[i];
						const record = records[i];
						if (!record.promotionalImage) continue;
						try {
							const realUrl = await this.$oss.getDownloadUrl(record.promotionalImage);
							if (!realUrl) continue;
							const target = this.tableData.find(p => p.id === record.id);
							if (target) {
								target.url = realUrl;
								target.imgLoaded = true;
							}
						} catch (imgErr) {
							console.error('图片加载失败', record.promotionalImage, imgErr);
						}
					}
				}
				loadImageSerial();

			} catch (err) {
				console.error(err)
				this.$message.error('查询失败')
			} finally {
				this.loadingClose()
				this.loading = false
				this.$nextTick(() => {
					if (this.noMore) return
					const scrollDom = this.$refs.scrollContainer
					if (!scrollDom) return
					const noScrollBar = scrollDom.scrollHeight <= scrollDom.clientHeight
					if (noScrollBar) {
						this.fetchProjectList()
					}
				})
			}
		},
		onScroll(e) {
			if (this.loading || this.noMore) return
			const dom = e.target
			const bottomGap = dom.scrollHeight - dom.scrollTop - dom.clientHeight
			if (bottomGap <= 50) {
				this.fetchProjectList()
			}
		}
	}
}


</script>

<style scoped>
.token-stat-page {
	padding: 18px;
	box-sizing: border-box;
}
.card-wrap {
	max-height: calc(100vh - 140px);
	overflow-y: auto;
	padding: 2px 6px 12px 2px;
	margin-top:10px;
}
.card-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
	gap: 16px;
}
.project-card {
	overflow: hidden;
	min-height: 184px;
	position: relative;
	background:
		radial-gradient(circle at 94% 12%, rgba(64, 158, 255, .12), transparent 28%),
		linear-gradient(135deg, #ffffff 0%, #f8fbff 56%, #eef7ff 100%);
	border-radius: 16px;
	padding: 18px 18px 16px;
	padding-right: 100px;
	border: 1px solid rgba(126, 154, 186, .16);
	box-shadow: 0 12px 30px rgba(31, 65, 105, .08);
	transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
}
.project-card:hover {
	transform: translateY(-3px);
	background:
		radial-gradient(circle at 94% 12%, rgba(64, 158, 255, .16), transparent 28%),
		linear-gradient(135deg, #ffffff 0%, #f8fbff 56%, #eef7ff 100%);
	box-shadow: 0 18px 44px rgba(31, 65, 105, .13);
	border-color: rgba(64, 158, 255, .28);
}

.card-title-row {
	font-size: 18px;
	font-weight: 800;
	color: #172033;
	margin-bottom:8px;
}
.card-id-text {
	font-size: 14px;
	color: #667085;
	line-height:1.6;
	margin-bottom:8px;
}
.card-desc {
	font-size:14px;
	color:#667085;
	line-height:1.65;
	margin:0 0 12px 0;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
}

.card-bottom {
	display:flex;
	flex-direction:column;
	gap:8px;
}
.type-tag {
	background: rgba(47, 128, 237, .1);
	color: #2f80ed;
	padding: 4px 9px;
	border-radius: 999px;
	font-weight: 700;
	width:fit-content;
}
.author-line {
	font-size:12px;
	color:#6b7280;
	display:flex;
	gap:12px;
}

/* 右上角图标，和智能体广场位置尺寸完全对齐 */
.card-icon {
	position: absolute;
	right: 16px;
	top: 16px;
	width: 78px;
	height: 78px;
	border-radius: 18px;
	overflow: hidden;
	border: 1px solid rgba(255, 255, 255, .8);
	box-shadow: 0 14px 30px rgba(31, 65, 105, .14);
}
.cover-img {
	width:100%;
	height:100%;
	object-fit: cover;
}
.icon-placeholder {
	width:100%;
	height:100%;
	background:#f1f5f9;
}

.load-tip {
	text-align: center;
	padding: 16px 0;
	font-size: 13px;
	color: #9ca3af;
}
.load-tip.no-more {
	color: #6b7280;
}
.empty-tip {
	padding:40px 0;
	text-align:center;
	color:#999;
	grid-column: 1 / -1;
}

@media (max-width: 650px) {
	.token-stat-page {
		padding: 10px;
	}
	.card-wrap {
		max-height: calc(100vh - 200px);
	}
	.card-grid {
		grid-template-columns:1fr;
	}
	.project-card {
		padding-right:18px;
	}
}
.card-more-wrap {
  position: absolute;
  right: 14px;
  bottom: 14px;
  z-index: 5;
}
.more-btn {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  cursor: pointer;
  opacity: 0;
  transition: opacity .2s;
  background: rgba(255, 255, 255, .88);
  box-shadow: 0 8px 18px rgba(31, 65, 105, .1);
}
.project-card:hover .more-btn {
  opacity: 1;
}
.more-btn:hover {
  background: #f1f1f1;
}

</style>

